import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2, ScrollText } from "lucide-react";

export default function Audit() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)); }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-head text-2xl lg:text-3xl font-semibold text-slate-900 flex items-center gap-2"><ScrollText className="h-6 w-6" /> Audit Trail</h1>
        <p className="text-slate-500 text-sm mt-1">Immutable record of every important action.</p>
      </div>

      <Card className="border-border overflow-hidden">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>When</TableHead><TableHead>User</TableHead><TableHead>Action</TableHead>
                <TableHead>Reference</TableHead><TableHead>Previous</TableHead><TableHead>New</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {logs === null && <TableRow><TableCell colSpan={6} className="text-center py-10"><Loader2 className="h-5 w-5 animate-spin mx-auto text-slate-400" /></TableCell></TableRow>}
              {logs && logs.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-slate-400 py-10">No audit records yet.</TableCell></TableRow>}
              {logs && logs.map((l) => (
                <TableRow key={l.id} data-testid={`audit-row-${l.id}`}>
                  <TableCell className="text-xs text-slate-500 whitespace-nowrap">{new Date(l.timestamp).toLocaleString("en-GB")}</TableCell>
                  <TableCell className="text-slate-700">{l.user_name}</TableCell>
                  <TableCell><span className="text-sm font-medium text-slate-800">{l.action}</span></TableCell>
                  <TableCell className="text-slate-600 text-sm">{l.entity_ref}</TableCell>
                  <TableCell className="text-slate-500 text-xs max-w-[160px] truncate">{fmt(l.previous_value)}</TableCell>
                  <TableCell className="text-slate-500 text-xs max-w-[160px] truncate">{fmt(l.new_value)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Card>
    </div>
  );
}

function fmt(v) {
  if (v == null) return "—";
  if (typeof v === "object") return Object.entries(v).map(([k, val]) => `${k}: ${val}`).join(", ");
  return String(v);
}
